/**
 * Moneda POS = canónica es-AR (`$950`, `$1.316,70`).
 * Delega a shared/format/formatMoney. `toLocaleString` pelado dropea el cero
 * final de fracciones ($433,3) — usar siempre este helper.
 */
export { formatMoney as formatPosMoney } from '../../shared/format/public-api';
